import { memo, useEffect, useRef, useState } from "react";
import { colors } from "constants/colors";
import { API_IMAGE_CONTEXT } from "constants/api";
import { StyledText } from "styles/Text";
import * as Styles from "./RevealMusicToggle.styles";

// 임밍아웃 리포트 배경음악 토글
const RevealMusicToggle = () => {
  const isPlayingRef = useRef(false);
  const audioRef = useRef<HTMLAudioElement | null>(null);

  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    isPlayingRef.current = isPlaying;
  }, [isPlaying]);

  useEffect(() => {
    const audio = new Audio(
      `${API_IMAGE_CONTEXT}/front/pregnancyRevealReport/bg_music.mp3`,
    );
    if (!audio.canPlayType("audio/mpeg")) return;

    audio.loop = true;
    audio.volume = 0.5;
    audioRef.current = audio;

    const onVisibilityChange = () => {
      if (!audioRef.current || !isPlayingRef.current) return;

      if (document.hidden) {
        audioRef.current.pause();
      } else {
        audioRef.current.play().catch(() => {});
      }
    };

    document.addEventListener("visibilitychange", onVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", onVisibilityChange);
      audioRef.current?.pause();
      audioRef.current = null;
    };
  }, []);

  const onPress = () => {
    const audio = audioRef.current;

    if (!audio) return;

    if (isPlaying) {
      audio.pause();
      setIsPlaying(false);
    } else {
      audio.play().catch(() => {});
      setIsPlaying(true);
    }
  };

  return (
    <Styles.StyledMusicBox type="button" onClick={onPress}>
      <Styles.StyledMusicWrapper>
        <Styles.StyledMusicIcon
          src={
            isPlaying
              ? `${API_IMAGE_CONTEXT}/front/pregnancyRevealReport/ic_musicon_normal_outlined_white_m.png`
              : `${API_IMAGE_CONTEXT}/front/pregnancyRevealReport/ic_musicoff_normal_outlined_white_m.png`
          }
          alt={isPlaying ? "music on" : "music off"}
        />
        <StyledText.Sub11 color={colors.white}>
          {isPlaying ? "ON" : "OFF"}
        </StyledText.Sub11>
      </Styles.StyledMusicWrapper>
    </Styles.StyledMusicBox>
  );
};

export default memo(RevealMusicToggle);
